import $i from "~/i18n";

export const toggleSidebarDashboard = (context, payload) => {
  console.log(payload)
  context.commit("toggleSidebarDashboard", payload);
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/sidebar/actions.js